module.exports = __webpack_public_path__ + "static/media/Chinthan.6e626d17.svg";